import React from 'react';
import { resolveKey, SCHEMAS } from '../../hooks/assetSchemaUtils';

type FieldType = 'text' | 'number' | 'date' | 'select';

interface Props {
  equipmentInventoryName?: string; // or equipmentCategoryName
  values: Record<string, any>;
  onChange: (name: string, value: any) => void;
  errors?: Record<string, string>;
  title?: string;
  disabled?: boolean;
  className?: string;
}

const DynamicAssetFields: React.FC<Props> = ({
  equipmentInventoryName,
  values,
  onChange,
  errors = {},
  title = 'Asset-Specific Information',
  disabled = false,
  className = '',
}) => {
  const key = resolveKey(equipmentInventoryName);
  if (!key || !SCHEMAS[key]) return null;

  const fields = SCHEMAS[key];

  return (
    <div className={`bg-white rounded-lg shadow-lg p-6 ${className}`}>
      <h2 className="text-lg font-semibold text-gray-800 mb-4">{title}</h2>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {fields.map((f) => {
          const raw = values[f.name];
          const viewVal = f.toView ? f.toView(raw) : raw ?? '';
          const span = f.colSpan ? `md:col-span-${f.colSpan}` : '';
          const err = errors[f.name];

          return (
            <div key={f.name} className={span}>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                {f.label}
              </label>
              {f.type === 'select' ? (
                <select
                  disabled={disabled}
                  value={viewVal}
                  onChange={(e) =>
                    onChange(f.name, f.toStore ? f.toStore(e.target.value) : e.target.value)
                  }
                  className={`w-full border rounded-lg px-3 py-2 ${err ? 'border-red-300' : 'border-gray-300'}`}
                >
                  {(f.options || []).map((opt) => (
                    <option key={opt.value} value={opt.value}>
                      {opt.label}
                    </option>
                  ))}
                </select>
              ) : (
                <input
                  disabled={disabled}
                  type={f.type}
                  value={viewVal}
                  placeholder={f.placeholder}
                  onChange={(e) =>
                    onChange(
                      f.name,
                      f.toStore
                        ? f.toStore(e.target.value)
                        : f.type === 'number'
                          ? (e.target.value === '' ? '' : Number(e.target.value))
                          : e.target.value
                    )
                  }
                  className={`w-full border rounded-lg px-3 py-2 ${err ? 'border-red-300' : 'border-gray-300'}`}
                />
              )}
              {err && <p className="text-red-500 text-sm mt-1">{err}</p>}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default DynamicAssetFields;
